export default __webpack_public_path__ + "static/media/arrow_back.c764a74d.svg";